export enum LocalStorageKeys {
  SAVE_VISIT_PAGE_KEY = 'pagination_save_visits_table',
  SAVE_VISIT_FILTER_KEY = 'visit_order_filters',
  TOKEN = 'token',
  AREA_CODES = 'areaCodes',
  PIMS_PARAMETERS = 'pimsParameters',
  TEMP_USER_LOGIN_FLAG = 'temp_user_login_flag',
  WAITING_ROOM_PAGINATION_MEDICATION_FILTER = 'filter_medications',
}

export const getCachedValue = (key: LocalStorageKeys): any => {
  const value = localStorage.getItem(key);
  return value ? JSON.parse(value) : undefined;
};

export const setCachedValue = (key: LocalStorageKeys, value: any): void => {
  if (key && value) {
    localStorage.setItem(key, JSON.stringify(value));
  }
};

export const removeCachedValue = (key: LocalStorageKeys) => localStorage.removeItem(key);
